import { useDispatch } from 'react-redux';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { isSameUserType } from '../../../../utils/helperFunction';
import { getCroList } from '../../../../redux/features/crmSlice';
import { crmTypes } from '../../../../utils/employeeTypes';
import { getCROlistUnderProject } from '../../../../redux/features/CRDslice';
import { FOUNDATION_DEPARTMENT_ID } from '../../../../utils/constants/departmentDetails';
import { useSelector } from 'react-redux';
import { croIndividualAccountsHeader } from './utils/croIndividualAccountsHeader';
import dayjs from 'dayjs';
import { getCroIndividualAccountsTable, getMonthlyAccounts } from '../../../../redux/features/crdMigrationSlice';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { MONTHS_WITHOUT_ALL } from '../../../../utils/courseIncome/constaints';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import AddNoteModalContent from './AddNoteModalContent';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export default function CroIndividualAccounts({ croView = false }) {
  // normal variable
  const dispatch = useDispatch();

  /***********************************************/
  // redux state

  const croList = useSelector((state) => state.crm.croList);
  const crosunderproject = useSelector((state) => state.crd?.crosunderproject);

  const croIndividualAccountsTable = useSelector((state) => state.crdMigration.croIndividualAccountsTable.data);
  const croIndividualAccountsLoading = useSelector((state) => state.crdMigration.croIndividualAccountsTable.loading);

  const monthlyAccountsTable = useSelector((state) => state.crdMigration.monthlyAccounts.data);
  const summary = useSelector((state) => state.crdMigration.monthlyAccounts.summary);
  const monthlyAccountsLoading = useSelector((state) => state.crdMigration.monthlyAccounts.loading);

  const meta = useSelector((state) => state.crdMigration.croIndividualAccountsTable.meta);

  const [refresh, setRefresh] = useState(false);
  /***********************************************/

  // react state
  const [cro, setCro] = useState({ userID: '', name: '' });
  const [month, setMonth] = useState({ id: dayjs().month() + 1, value: '' });
  const [year, setYear] = useState(dayjs().year());
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });
  /***********************************************/

  // dispatch Params
  const dispatchParams = useMemo(
    () => ({
      ...(croView
        ? []
        : {
            page: tableState?.page,
            limit: tableState?.pageSize,
            search: tableState?.search,
            sortBy: tableState?.sort?.field,
            sortOrder: tableState?.sort?.direction,
          }),
      cro_id: cro?.userID === -1 ? null : cro?.userID,
      year,
      month: month?.id,
    }),
    [
      ...(croView ? [] : [tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize]),
      cro,
      month,
      year,
    ],
  );

  /***********************************************/

  // ----- Memozisation
  const isCrm = useMemo(() => {
    const profile = JSON.parse(localStorage.getItem('cred')).profile;
    return isSameUserType({ roleArray: crmTypes, role: profile?.role });
  }, []);

  // mounting Fetch
  // ----- fetch common without dependancy

  useEffect(() => {
    if (!croView) {
      dispatch(isCrm ? getCroList({ search: '' }) : getCROlistUnderProject(FOUNDATION_DEPARTMENT_ID));
    }
  }, [dispatch, isCrm, croView]);

  useEffect(() => {
    if (croView) dispatch(getMonthlyAccounts(dispatchParams));
    else dispatch(getCroIndividualAccountsTable(dispatchParams));
  }, [dispatch, dispatchParams, croView, refresh]);

  /***********************************************/

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    // console.log("action type",actionType);
    if (!actionKey || !row) return;
    if (actionKey === 'ledgerNavigate') {
      const url = `/my-workspace/ledger-view-cro?admissionNo=${row?.admn_no}&studentName=${row?.student_name}&course=${row?.course_name}&courseEnrollmentId=${row?.course_enrollment_id}`;
      window.open(url, '_blank');
    } else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  return (
    <GlobalWrapper title={croView ? 'Monthly Accounts' : 'CRO Individual Accounts'}>
      <Stack gap={1}>
        <Box display={'flex'} gap={1} flexDirection={{ xs: 'column', sm: 'row' }}>
          {!croView && (
            <Autocomplete
              options={
                isCrm ? [{ userID: -1, name: 'All' }, ...croList] : [{ userID: -1, name: 'All' }, ...crosunderproject]
              }
              getOptionLabel={(e) => e.name}
              isOptionEqualToValue={(opt, val) => opt.userID === val.userID}
              onChange={(e, v) => setCro(v)}
              sx={{ width: { xs: '100%', sm: 230 } }}
              renderInput={(params) => <TextField {...params} label="CRO Name" />}
            />
          )}

          <GlobalSelectFieldWithoutFormikNew
            data={MONTHS_WITHOUT_ALL}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            label={'Months'}
            selectedDetails={month}
            setChange={setMonth}
            sx={{
              maxWidth: { xs: '100%', sm: 180 },
              minWidth: { xs: '100%', sm: 150 },
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={'Year'}
              views={['year']}
              onChange={(v) => setYear(v?.year() ? v?.year() : dayjs().year())}
              value={dayjs().year(year)}
              sx={{
                maxWidth: { xs: '100%', sm: 180 },
              }}
            />
          </LocalizationProvider>
        </Box>
        <Box
          sx={{
            px: 2,
            py: 1,
            borderRadius: 2,
            bgcolor: '#f5f7fa',
            boxShadow: 2,
            display: 'inline-flex',
            alignSelf: 'flex-end',
            width: 'fit-content',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Balance Fee :
          </Typography>
          <Typography variant="subtitle2" fontWeight={600} ml={0.5}>
            ₹{croView ? summary?.total_negative_balance : meta?.total_balance}
          </Typography>
        </Box>
        {croView ? (
          <GlobalTableNoPagination
            rowUniqueId="sl_no"
            headers={croIndividualAccountsHeader(croView)}
            rows={monthlyAccountsTable}
            tableState={tableState}
            setTableState={setTableState}
            loading={monthlyAccountsLoading}
            onButtonActionClick={handleButtonActionClick}
          />
        ) : (
          <GlobalTable
            rowUniqueId="sl_no"
            headers={croIndividualAccountsHeader(croView)}
            rows={croIndividualAccountsTable}
            tableState={tableState}
            setTableState={setTableState}
            loading={croIndividualAccountsLoading}
            meta={meta}
            onButtonActionClick={handleButtonActionClick}
          />
        )}
      </Stack>
      <Box>
        <GlobalDialog
          title={'Add Note'}
          open={Boolean(modalState?.actionKey)}
          setOpen={(val) => {
            if (!val) setModalState({ actionKey: '', row: null });
          }}
          closeButton={true}
          content={<AddNoteModalContent row={modalState.row} setOpenModal={setModalState} setRefresh={setRefresh} />}
          maxWidth={'md'}
          fullWidth={true}
        />
      </Box>
    </GlobalWrapper>
  );
}
